var React = require('react');

function IcShare (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18 7a2 2 0 100-4 2 2 0 000 4zm0 2a4 4 0 10-3.933-3.27L7.603 8.964A4 4 0 108.04 14.6l6.062 3.5a4 4 0 10.925-1.776L8.92 12.799a4.018 4.018 0 00-.164-2.177l6.157-3.078A3.992 3.992 0 0018 9zm0 12a2 2 0 100-4 2 2 0 000 4zM7 12a2 2 0 11-4 0 2 2 0 014 0z","fill":"currentColor"}));
}

IcShare.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IcShare;

IcShare.default = IcShare;
